<div class="login-container justify-content-center">
  <div class="login-module">
    <div class="login-logo">
      <img src="assets/images/MWP_Blue_Main_Logo.webp" alt="My workplace logo" />
    </div>
    @if (!isFAQ) {
    <div class="header">
      <div class="title">
        <mwp-text-translate [text]="title" [jsonKey]="jsonKeyTitle" />
      </div>
    </div>
    <div class="login-form-container">
      <div class="login-form">
        <mwp-translation />
        <mwp-password [isAgent]="isAgent" [baseMemberSessionList]="baseMemberSessionList" [agentLoginId]="agentLoginId" [displayHeader]="false" (emitPassword)="submitPassword($event)" />
      </div>
    </div>
    }
    @if (isFAQ) {
    <div class="faq-container">
      <div class="header">
        <div class="title w-100">
          <mwp-text-translate [text]="title" [jsonKey]="jsonKeyTitle" />
        </div>
      </div>
      <mwp-login-faq [LoginType]="loginType" />
    </div>
    }
  </div>
</div>